// extracted by mini-css-extract-plugin
module.exports = {"Animation":"Animation_Animation__3y4CC","fadeIn":"Animation_fadeIn__2lp15","Hide":"Animation_Hide__1MPSH"};